import { render } from "./EventsPage.vue?vue&type=template&id=4c49eddc"
import script from "./EventsPage.vue?vue&type=script&lang=js"
export * from "./EventsPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./EventsPage.vue?vue&type=style&index=0&id=4c49eddc&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__